(ns ui.components.input.multiplier
  (:require
   [clojure.string :as string]
   [common.number-format :as number-format]
   [common.util :as cu]
   [ui.components.input.number :as number-input]
   [ui.constants :as constants]
   [ui.util :as util]))

(defn parse-value
  [str-value number-format]
  (let [str-value (cu/str-trim-lcase str-value)
        ends-with-x? (string/ends-with? str-value "x")
        numeric-str (if ends-with-x?
                      (subs str-value 0 (dec (count str-value)))
                      str-value)
        float-meta (util/parse-float-info
                    (if number-format
                      (number-format/decimal-separator number-format)
                      constants/decimal-separator)
                    numeric-str
                    nil)
        {:keys [float-value]} float-meta
        is-within-bounds? (and (number? float-value)
                               (< constants/MIN-SAFE-INTEGER float-value constants/MAX-SAFE-INTEGER))]
    (if is-within-bounds?
      float-value
      nil)))

(defn view
  [props]
  [number-input/view
   (merge
    props
    {:multiplier-mode? true
     :min-decimals     2
     :max-decimals     2})])
